export default __webpack_public_path__ + "static/media/ecosystemBG.d6a14a39.png";